import React, { FC } from 'react';


export type RatingSartsProps = {
    rating: number
}


export const RatingSarts: FC<RatingSartsProps> = (props) => {

    const { rating } = props

    const Star = ({ shape }) => <i className={`elementor-star-${shape}`}>&#xE934;</i>

    let stars = []

    for(let i = 0; i < 5; i++) {
        if(!rating || i >= rating) {
            stars.push(<Star key={i} shape="empty" />)
        } else if(i < rating) {
            stars.push(<Star key={i} shape="full" />)
        } else {
            stars.push(<Star key={i} shape={(rating % 1).toFixed(1).substring(2)} />)
        }
    }

    return (<>{stars}</>)
}

